"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Base = _interopRequireDefault(require("Base64"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Sets auth headers if necessary
function addAuthHeaders(_ref) {
  var auth = _ref.auth,
      bearerToken = _ref.bearerToken,
      headers = _ref.headers,
      _ref$overrideHeaders = _ref.overrideHeaders,
      overrideHeaders = _ref$overrideHeaders === void 0 ? false : _ref$overrideHeaders;
  if (overrideHeaders) return;
  if (bearerToken) return {
    headers: _objectSpread({}, headers, {
      Authorization: "Bearer ".concat(bearerToken)
    })
  };

  if (auth) {
    var username = auth.username || '';
    var password = auth.password || '';

    var encodedToken = _Base["default"].btoa("".concat(username, ":").concat(password));

    return {
      headers: _objectSpread({}, headers, {
        Authorization: "Basic ".concat(encodedToken)
      })
    };
  }
}

var _default = addAuthHeaders;
exports["default"] = _default;